import { PORT1 } from '@/api/config/servicePort'
import http from '@/api'

/**
 * @name 校园/社会招聘简历投递
 */
// 获取简历上传 OSS 凭证
export const getResumePolicy = params => {
  return http.get(PORT1 + `/user/campus/resume/getResumePolicy`, params)
}

// 提交简历
export const submitResume = params => {
  return http.post(PORT1 + `/user/campus/resume/submitResume`, params)
}

// 查询本人投递状态
export const querySelfResumeStatus = params => {
  return http.post(PORT1 + `/user/campus/resume/querySelfResumeStatus`, params)
}
